<script lang="ts">
  import { onMount } from "svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import ListPrice from "./ListPrice.svelte";
  import DealPrice from "./DealPrice.svelte";
  import ProductContainerDetails from "@shared/filters/product_container_details.js";
  import DealsCartWidgetContainer from "@retailer/svelte/CartWidget/v2/Containers/DealsCartWidgetContainer.svelte";
  import { DealTierProductEntity } from "@shared/services/event_tracking/entities";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";

  import type { Product } from "@shared/types/ProductLine";
  import type { Discount } from "@shared/types/Deals";

  export let discount: Discount;
  export let dealActive: boolean = false;
  export let products: { [key: number]: Product };
  export let isRip: boolean = false;

  const product: Product = products[discount.product_id];

  const trackingEntities = [
    new DealTierProductEntity({
      product_id: product.id,
      deal_tier_id: discount.deal_tier_id,
      distributor_id: product.distributor_id,
      product_group_id: null,
      sku: product.sku,
    }),
  ];

  function getUnitPrice(discount: Discount) {
    // unit_price != discount.case_price: Fallback handling for Eagle Rock pricing data.
    if (!discount.unit_price) {
      return discount.case_price / (discount.container_case_size || 1);
    }
    return discount.unit_price != discount.case_price
      ? discount.unit_price
      : discount.case_price / (discount.container_case_size || 1);
  }

  function productContainerDetails(discount: Discount) {
    return ProductContainerDetails()(discount, null, null, true);
  }

  let inventoryItemLoaded: boolean = false;

  onMount(async () => {
    inventoryItemLoaded = false;
    const response = await InventoryItemStore.fetchInventoryItem(product.inventory_id);
    inventoryItemLoaded = response?.loaded;
  });
</script>

<tr class="deal-show__product-row" data-product-id={product.id}>
  <td>
    <p>
      <UIRouterLink
        stateName="layout.product_detail"
        classes="deal-show__product-row-link-hover"
        params={{ productId: discount.product_line_id }}
      >
        <strong>{discount.product_line_name}</strong>
      </UIRouterLink>
      <br />
      <span>
        {productContainerDetails(discount)}
      </span>
    </p>
  </td>

  <td data-label="List Price" class="fizz-align-content-start">
    <ListPrice {discount} {getUnitPrice} inventoryId={product.inventory_id} />
  </td>

  {#if !isRip}
    <td data-label="Deal Price" class="fizz-align-content-start">
      <DealPrice {discount} {getUnitPrice} inventoryId={product.inventory_id} />
    </td>
  {/if}
  {#if dealActive}
    <DealsCartWidgetContainer
      inventoryId={product.inventory_id}
      {trackingEntities}
      loaded={inventoryItemLoaded}
    />
  {/if}
</tr>
